import { Can } from 'providers/casl'

export const onFinanceAccess = (can: Can) => {
  can('access', 'FinancePage')
}
